export default {
    data() {
        return {
            cutH: 90,
            cutH2:222,
            cutH3:228,
            cutH4:160,
            mainHeight:'',
            mainHeight2:'',
            mainHeight3:'',
            mainHeight4:''
        }
    },
    mounted() {
        this.mainHeight = window.innerHeight - this.cutH;
        this.mainHeight2 = window.innerHeight - this.cutH2;
        this.mainHeight3 = window.innerHeight - this.cutH3;
        this.mainHeight4 = window.innerHeight - this.cutH4;
        window.addEventListener("resize", this.windowResize, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.windowResize, false)
    },
    methods: {
        windowResize() {
            this.mainHeight = window.innerHeight - this.cutH;
            this.mainHeight2 = window.innerHeight - this.cutH2;
            this.mainHeight3 = window.innerHeight - this.cutH3;
            this.mainHeight4 = window.innerHeight - this.cutH4;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/windowResize.js